export const SecondaryButton = ({
  type,
  onClick,
  disabled,
  children,
  className,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-soft-cyan-300 ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
